let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cEn34")).then(() => parcelRequire('f1k06'));